import { createContext, useContext, useState, ReactNode } from "react";

interface LayoutContextType {
    showUtilityBarSpace: boolean;
    setShowUtilityBarSpace: (show: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function useLayoutContext() {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error("useLayoutContext must be used within a LayoutProvider");
    }
    return context;
}

interface LayoutProviderProps {
    children: ReactNode;
}

export function LayoutProvider({ children }: LayoutProviderProps) {
    const [showUtilityBarSpace, setShowUtilityBarSpace] = useState(true);

    return <LayoutContext.Provider value={{ showUtilityBarSpace, setShowUtilityBarSpace }}>{children}</LayoutContext.Provider>;
}
